import {IComponentOptions} from 'angular';
import TSBenutzer from '../../../models/TSBenutzer';
import TSAnlaufstelle from '../../../models/TSAnlaufstelle';
import AnlaufstelleRS from '../../../core/service/AnlaufstelleRS.rest';
import {IStateService} from 'angular-ui-router';
import {IAnlaufstelleBenutzerEditStateParams} from '../../benutzerverwaltung.route';

let template = require('./benutzerverwaltungAnlaufstelleView.html');

/**
 * Diese Komponente diente dazu Benutzer einer bestimmten Anlaufstelle zu editieren, wahrscheinlich ist dies
 * nun gar nicht mehr noetig da wir die Benutzerverwaltung separat fuehren.
 * Diese component kann somit erstmal als deprecated betrachtet werden. Allenfalls koennen wir sie spaeter auch loeschen
 * @deprecated
 */
export class BenutzerverwaltungAnlaufstelleViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = BenutzerverwaltungAnlaufstelleViewController;
    controllerAs: string = 'vm';
    bindings: any = {
        benutzerToShow: '<',
        allowedAnlaufstellen: '<'
    };
}

export class BenutzerverwaltungAnlaufstelleViewController {
    benutzerToShow: Array<TSBenutzer>;
    allowedAnlaufstellen: Array<TSAnlaufstelle>;
    selectedAnlaufstelle: TSAnlaufstelle;

    loadedAnlaufstelleId: string; //remember id of currently loaded anlaufstelle

    static $inject = ['AnlaufstelleRS', '$state'];

    /* @ngInject */
    constructor(private anlaufstelleRS: AnlaufstelleRS, private $state: IStateService) {
    }

    $onInit() {
        if (this.allowedAnlaufstellen && this.allowedAnlaufstellen.length !== 0) {
            this.selectedAnlaufstelle = this.allowedAnlaufstellen[0];
            this.loadedAnlaufstelleId = this.selectedAnlaufstelle.id;
        }

    }

    public changedAnlaufstelle() {
        if (this.loadedAnlaufstelleId !== this.selectedAnlaufstelle.id) {
            this.anlaufstelleRS.getBenutzerOfAnlaufstelle(this.selectedAnlaufstelle.id)
                .then((result) => {
                    this.loadedAnlaufstelleId = this.selectedAnlaufstelle.id;
                    this.benutzerToShow = result;
                });
        }
    }

    public hasExactlyOneAllowedAnnahmestelle() {
        if (this.allowedAnlaufstellen && this.allowedAnlaufstellen.length === 1) {
            return true;
        }
        return false;
    }

    public editBenutzer(benutzer: TSBenutzer, event: any) {
        let params: IAnlaufstelleBenutzerEditStateParams = {
            anlaufstelleId: this.selectedAnlaufstelle.id,
            benutzerId: benutzer.id,
            benutzer: benutzer
        };
        this.$state.go('benutzereditanlaufstelle', params)
    }

    public addBenutzer() {
        let createdBenutzer = new TSBenutzer();
        let params: any = {anlaufstelleId: this.selectedAnlaufstelle.id, benutzerId: undefined, benutzer: createdBenutzer};
        this.$state.go('benutzereditanlaufstelle', params);

    }

}



// WEBPACK FOOTER //
// ./src/app/benutzerverwaltung/component/benutzerverwaltungAnlaufstelleView/benutzerverwaltungAnlaufstelleView.ts